import { render, staticRenderFns } from "./Clocks.vue?vue&type=template&id=06adbbbe&scoped=true&"
import script from "./Clocks.vue?vue&type=script&lang=js&"
export * from "./Clocks.vue?vue&type=script&lang=js&"
import style0 from "./Clocks.vue?vue&type=style&index=0&id=06adbbbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06adbbbe",
  null
  
)

export default component.exports